export default class MeasurementCounters {
  good = 0;
  caution = 0;
  bad  = 0;

  getTotal(): number {
    return this.good + this.caution + this.bad;
  }
}
